export default {"src":"/_next/static/media/mb-bw-small.4f0609d6.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};